import { Component } from 'react'
import { OperationStart } from 'stylewhere/components'
import { Shippings, ShippingParcel, OperationConfigurations } from 'stylewhere/api'
import { ShippingExtensions } from 'stylewhere/extensions'
import { ShippingOperationConfig, RemoteOperation, Router, getDataFromSchema } from 'stylewhere/shared'
import { PackingOperationConfig, RawOperationConfig } from 'stylewhere/shared/RemoteOperation'
import type { Routes } from 'stylewhere/pages'
import { CustomError } from 'stylewhere/shared/errors'
import { isModalError, showToastError } from 'stylewhere/utils'
import { __, T } from 'stylewhere/i18n'

export interface ShippingStartParams {
  opCode: string
}

interface ShippingStartProps {
  match: { params: ShippingStartParams }
  history: any
}

export default class WithEncodingStart extends Component<ShippingStartProps> {
  submitPath: Routes = '/shipping/withEncoding/:opCode/reading'
  isModal = false

  get operation() {
    return RemoteOperation.getOperationConfig<ShippingOperationConfig | PackingOperationConfig>(
      this.props.match.params.opCode
    )
  }

  componentDidMount() {
    this.isModal = isModalError(this.operation)
    this.checkEncodingOperation()
  }

  checkEncodingOperation = async () => {
    // get related encoding operation
    const encodingOperationConfig = await OperationConfigurations.search<RawOperationConfig>({
      size: 1,
      equalCodes: this.operation.validateEncodingOperationCode
    })
    if (!encodingOperationConfig || !encodingOperationConfig.content || encodingOperationConfig.content.length === 0) {
      showToastError(new Error('Missing embedded encoding operation'), __(T.error.error), true)
      Router.navigate('/')
      return
    }
  }

  onSubmit = async (formData, operation: ShippingOperationConfig, schema) => {
    if (schema.length === 0) {
      // auto submit
      Router.navigate(this.submitPath, { opCode: this.operation.code }, {})
      return
    }

    const payloadStartParcel: any = getDataFromSchema(formData, schema)
    try {
      const parcel: ShippingParcel = await Shippings.startParcel(
        this.operation,
        payloadStartParcel,
        this.operation.startParcelWithAsn
      )
      if (!formData.parcelCode && parcel?.code && schema.some((s) => s.name === 'parcelCode')) {
        formData.parcelCode = parcel.code
      }
      Router.navigate(this.submitPath, { opCode: operation.code }, { state: { formData, parcel } })
    } catch (e) {
      if (e instanceof CustomError) {
        showToastError(
          `${CustomError.interpolateMessage(e.message, payloadStartParcel)}. [${e.errorCode}]`,
          __(T.error.error),
          this.isModal,
          () => {}
        )
        return
      }
      showToastError(e, 'Start Parcel Error', this.isModal, () => {})
    }
  }

  render() {
    return <OperationStart submitPath={this.submitPath} extensions={ShippingExtensions} onSubmit={this.onSubmit} />
  }
}
